<template>
  <div v-if="lastSeenItems && lastSeenItems.length > 0" class="crosselling-list-overlay__content">
    <p class="crosselling-list-overlay__headline h4 font-weight-bold mb-3">{{ $translate("KMSVueTheme::SingleItemTheme.ATBLastSeenItemsHeadline") }}</p>
    <div class="crosselling-list-overlay__grid">
      <div v-for="item in itemsToShow" :key="item.id" class="crosselling-list-overlay__item">
        <category-item :decimal-count="$ceres.config.item.storeSpecial">
          <template #before-prices>
            <div v-html="getContainerContentById(item.id, 'beforePrices')"></div>
          </template>
          <template #after-prices>
            <div v-html="getContainerContentById(item.id, 'afterPrices')"></div>
          </template>
          <template #item-data>{{ item.data }}</template>

          <a :href="getItemUrl(item.data)" class="small">
            <i class="fa fa-image" aria-hidden="true"></i>
            <span>{{ getItemName(item.data) }}</span>
          </a>
        </category-item>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "last-seen-grid",

  props: {
    maxItems: {
      type: Number,
      default: 8,
    },
  },

  computed: {
    ...mapState({
      lastSeenItems: (state) => state.lastSeen.lastSeenItems,
      containers: (state) => state.lastSeen.containers,
    }),

    itemsToShow() {
      if (this.lastSeenItems && this.lastSeenItems.length > 0) {
        return this.lastSeenItems.slice(0, this.maxItems);
      }
      return [];
    },
  },

  beforeMount() {
    // Lade LastSeen Items aus dem Store
    this.$store.dispatch("getLastSeenItems");
  },

  methods: {
    getItemUrl(itemData) {
      if (itemData && itemData.variation && itemData.variation.id) {
        return this.$options.filters.itemURL(itemData);
      }
      return "#";
    },

    getItemName(itemData) {
      if (itemData && itemData.texts && itemData.texts.length > 0) {
        return itemData.texts[0].name1 || "";
      }
      return "";
    },

    getContainerContentById(variationId, containerKey) {
      const containersById = this.containers[variationId];

      if (containersById != null && containersById !== undefined) {
        const container = containersById[containerKey];

        if (container != null && container !== undefined) {
          return container;
        }
      }

      return "";
    },
  },
};
</script>
